import PRLTCFan from "./PRLTCFan";

export default function ExternalFan({ frame, selected }) {
  return <PRLTCFan frame={frame} selected={selected} />;
}
